import { Component, OnInit } from '@angular/core';
import { getRandomColor } from '../t1-workspace/widgets/shared/utils';
import { WrapperService } from '../service/wrapper/wrapper.service';
import { AccountDetailsService } from '../service/account-details/account.details.service';
import { ServiceUtils } from '../service/service-globals';

@Component({
  selector: 'sam-frontend-admin-username-header',
  templateUrl: './username-header.component.html',
  styleUrls: ['./username-header.component.css'],
  standalone: false,
})
export class UsernameHeaderComponent implements OnInit {
  public getRandomColor = getRandomColor;
  user: any;
  name_initials: string = '';
  public userOrgObj = null;
  public hierarchy = {
    department: '',
    agency: '',
    office: '',
    aac: '',
    cgac: '',
    fpdsCode: '',
  };

  constructor(
    private wrapperService: WrapperService,
    private acctDetailsService: AccountDetailsService,
    private serviceUtils: ServiceUtils,
  ) {
    // Intentionally blank. Comment is here to satisfy SonarQube
  }

  ngOnInit() {
    this.getUserInfo();

    this.serviceUtils.updateAccountDetails.subscribe(() => this.getUserInfo());
  }

  public getUserInfo() {
    this.wrapperService.call({ name: 'session' }).subscribe((data) => {
      if (data) {
        this.user = data;

        const name = this.user?.fullName?.split(' ') || [];
        this.name_initials = (name[0]?.charAt(0) || '') + (name[1]?.charAt(0) || '');

        if (this.user?.agencyID == 0) this.hierarchy.agency = '';

        this.acctDetailsService?.userDataUpdate?.emit(this.user);
      }
      this.fetchOrgData();
    });
  }

  fetchOrgData(): void {
    if (this.user?.isGov) {
      const orgs = [this.user?.departmentID, this.user?.agencyID, this.user?.officeID];
      const filteredOrgs = orgs.filter(Boolean);
      if (filteredOrgs.length) {
        this.acctDetailsService.getOrganizationsByIds(filteredOrgs.join(',')).subscribe({
          next: (response) => {
            this.userOrgObj = response['_embedded']['orgs'];
            this.setFHDataForDisplay(this.userOrgObj);
          },
          error: (error) => console.log(error),
        });
      }
    }
  }

  setFHDataForDisplay(orgs: any[]): void {
    if (orgs) {
      this.acctDetailsService?.orgDataUpdate?.emit(orgs);
      if (orgs[1]) {
        const org = orgs[1]['org'];
        this.hierarchy.agency = org['name'];
      }
    }
  }
}
